theme.Hero = (function () {
  function Hero(container) {
    var $container = (this.$container = $(container));
    var id = (this.id = $container.attr("data-section-id"));
    var $featuredImage = (this.$featuredImage = $("#FeaturedImage-" + id));
    var featuredImageSelector = (this.featuredImageSelector =
      "#FeaturedImage-" + id);
    var parallaxSliderSelector = (this.parallaxSliderSelector =
      "#FeaturedImage-" + id + " .parallax-slider");
    
    var parallaxImageElement = (this.parallaxImageElement =
      "#FeaturedImage-" + id + " .hero-image");

    var $parallaxImageElement = (this.$parallaxImageElement = $(parallaxImageElement));

    var parallaxImageContainerSelector = (this.parallaxImageContainerSelector =
      "#FeaturedImage-" + id + " .hero-image-container");

    var $parallaxImageContainer = (this.$parallaxImageContainer =
      $(parallaxImageContainerSelector));
    this.init();
  }

  Hero.prototype = $.extend({}, Hero.prototype, {
    init: function () {


      if (this.$featuredImage.attr("data-parallax-src")) {

        jarallax(document.querySelectorAll(this.parallaxImageContainerSelector), {
            imgElement: '.hero-image',
            disableParallax: /iPad|iPhone|iPod|Android/,
        });

      } 
    },
    onUnload: function () {
      if (this.$featuredImage.attr("data-img-src")) {

        this.$featuredImage.jarallax('destroy');
      }
    },
  });
  return Hero;
})();